// extracted by mini-css-extract-plugin
module.exports = {"column":"TableColumn_column__Aw8-w","dense":"TableColumn_dense__2aXxP","clickable":"TableColumn_clickable__z154K"};